// extracted by mini-css-extract-plugin
export default {"center":"CampaignsPage_center__dunWT","fullCenter":"CampaignsPage_fullCenter__7AvJA","float":"CampaignsPage_float__IWEt2","uu":"CampaignsPage_uu__RKnt-"};